export const PROPERTY_TYPE_HOUSE = 'house';
export const PROPERTY_TYPE_FLAT = 'flat';
export const PROPERTY_TYPE_OFFICE = 'office';
export const TYPE_QUALITY = 'quality';
export const TYPE_STYLE = 'style';
export const TYPE_VALUE = 'value';
export const PROPERTY_TYPES = [
    PROPERTY_TYPE_HOUSE,
    PROPERTY_TYPE_FLAT,
    PROPERTY_TYPE_OFFICE,
    TYPE_QUALITY,
    TYPE_STYLE,
    TYPE_VALUE,

];
